import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Page } from '../../layout';
import { Breadcrumb } from '../../shared/components/breadcrumb/Breadcrumb';
import ResponsiveTabMenu from '../../shared/components/ResponsiveTabMenu';
import { useTabExistCheck } from '../../shared/hooks/useTabExistCheck';
import useUriFragment from '../../shared/hooks/useUriFragment';
import { getActiveTabDisplayName } from '../../shared/services/getActiveTabDisplayNameService';
import ORGANIZATION_SEARCH_PAGE_TABS from '../constants/OrganizationSearchPageTabs';
import UserListDownloader from '../../userManagement/components/userListDownloader/UserListDownloader';
import { OrganizationList } from './shared/components/OrganizationList';
import { useQuery } from '@apollo/client';
import useSearchState from '../hooks/useSearchState';
import ApolloError from '../../shared/components/ApolloError';
import GET_ORGANIZATIONS_WITH_LICENSES from '../queries/organizationLicenseQuery';

const PAGE_SIZE = 20;
const TABS = Object.values(ORGANIZATION_SEARCH_PAGE_TABS);

const UserManagementOrganizationSearch = () => {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useUriFragment(TABS);
  useTabExistCheck(TABS, activeTab);

  const activeTabDisplayName = getActiveTabDisplayName(TABS, activeTab);

  const isVipOrganization = activeTab === ORGANIZATION_SEARCH_PAGE_TABS.vipOrganization.value;

  const pageTitle = `Organization Search - ${activeTabDisplayName}`;

  const breadcrumbPathItems = [
    { name: 'User Management', url: '/user-management/organization-search' },
    { name: pageTitle, url: '' }
  ];

  const { currentPage, searchText, searchChar, searchOHT, setSearchState, filters } =
    useSearchState({ includeFeiSearch: true });

  const {
    data: searchResult,
    loading,
    error
  } = useQuery(GET_ORGANIZATIONS_WITH_LICENSES, {
    variables: {
      filters,
      offset: (currentPage - 1) * PAGE_SIZE,
      limit: PAGE_SIZE,
      isVipOrganization: isVipOrganization,
      includeDeactivated: true
    }
  });

  const organizations = searchResult?.mddapOrganizationsFiltered || [];
  const totalCount = searchResult?.mddapOrganizationsFilteredCount || 0;

  const handleTabChange = type => {
    setActiveTab(type);
  };

  const handleSelectOrganization = orgId => {
    navigate(`/user-management/${orgId}`);
  };

  if (error) {
    return <ApolloError />;
  }

  return (
    <Page title={pageTitle}>
      <Breadcrumb pathItems={breadcrumbPathItems}>
        <UserListDownloader />
      </Breadcrumb>
      <ResponsiveTabMenu activeTab={activeTab} tabs={TABS} onChange={handleTabChange} />
      <OrganizationList
        onSelectOrganization={handleSelectOrganization}
        shouldShowSearchControls={!isVipOrganization}
        organizations={organizations}
        totalCount={totalCount}
        loading={loading}
        searchTextPlaceholder='Search by Name or FEI #'
        searchState={{
          currentPage,
          searchText,
          searchChar,
          searchOHT,
          setSearchState
        }}
      />
    </Page>
  );
};

export default UserManagementOrganizationSearch;
